<template>
	<el-dialog v-dialogDrag title="搜索群聊" :visible.sync="visible" width="400px" :before-close="onClose"
		custom-class="search-group">
		<el-input placeholder="输入群号搜索群聊" v-model="searchText" size="small" @keyup.enter.native="onSearch()">
			<i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch()"> </i>
		</el-input>
		<div class="result-box">
			<div v-if="searched && !group" class="empty-tip">未找到该群聊，请确认群号是否正确</div>
			<div v-if="group" class="item">
				<div class="avatar">
					<head-image :name="group.name" :url="group.headImage" radius="20%" :size="54"></head-image>
				</div>
				<div class="group-info">
					<div class="group-name">{{ group.name }}</div>
					<div class="group-sub">
						<span>群号：{{ group.id }}</span>
						<span class="member-count">{{ group.memberCount }}人</span>
					</div>
				</div>
				<el-button type="primary" size="mini" v-if="!group.alreadyJoined" :loading="joining"
					@click="onJoin()">加入</el-button>
				<el-button type="info" size="mini" v-else plain disabled>已加入</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue'

export default {
	name: "searchGroup",
	components: { HeadImage },
	data() {
		return {
			searchText: "",
			group: null,
			searched: false,
			joining: false
		}
	},
	props: {
		dialogVisible: {
			type: Boolean
		}
	},
	computed: {
		visible: {
			get() {
				return this.dialogVisible;
			},
			set(val) {
				if (!val) {
					this.$emit("close");
				}
			}
		}
	},
	methods: {
		onClose() {
			this.searchText = "";
			this.group = null;
			this.searched = false;
			this.$emit("close");
		},
		onSearch() {
			const id = (this.searchText || "").trim();
			if (!id) {
				this.group = null;
				this.searched = false;
				return;
			}
			if (!/^\d+$/.test(id)) {
				this.$message.error("群号只能是数字");
				return;
			}
			this.$http({
				url: `/group/search/${id}`,
				method: "get"
			}).then((data) => {
				this.group = data;
				this.searched = true;
			}).catch(() => {
				this.group = null;
				this.searched = true;
			})
		},
		onJoin() {
			if (!this.group) {
				return;
			}
			this.joining = true;
			this.$http({
				url: `/group/join/${this.group.id}`,
				method: "post"
			}).then((groupVo) => {
				this.$message.success("已加入群聊");
				this.group.alreadyJoined = true;
				this.$emit("join", groupVo);
				this.onClose();
			}).finally(() => {
				this.joining = false;
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.search-group {
	.result-box {
		min-height: 80px;
		margin-top: 10px;

		.empty-tip {
			text-align: center;
			color: var(--im-text-color-light);
			font-size: 13px;
			padding: 24px 0;
		}

		.item {
			height: 74px;
			display: flex;
			align-items: center;
			padding: 0 6px;

			.group-info {
				margin-left: 14px;
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;

				.group-name {
					font-weight: 600;
					font-size: 16px;
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.group-sub {
					display: flex;
					align-items: center;
					font-size: 12px;
					color: var(--im-text-color-light);
					line-height: 20px;

					.member-count {
						margin-left: 12px;
					}
				}
			}
		}
	}
}
</style>
